module.exports = __webpack_public_path__ + "static/media/51_B.63cecf89.png";